import React, { Component } from "react";
import "./realestatehome.css";
import { t } from "i18next";
import RealEstate from "../../../assets/svgs/icons_svg/real_estate_img.svg";
import {
  BreadCrumb,
  Button,
  TitleView,
  SideModel,
} from "../../components";
import * as Bl from "../../../businesslogic";
import { FIXED_ASSETS_TYPE } from "../../constants";
import { getUserId } from "../../common";
import { getInvestmentPhysicalPath } from "../../common";

const newFixedAssets = {
  fixedassettype: FIXED_ASSETS_TYPE.REAL_ESTATE,
  currentvalue: 0,
  fixedassetdescription: "",
  assetinflation: 0,
  targetliquidationyear: 0,
  userid: "",
  expectedliquidationvalue: 0,
  isrented: false,
  assetdetails: [],
  fixedassetuuid: getUserId(),
  isliquidated: false,
  fvatretirement: 0,
  targetliquidationage: 0,
  isincludefinancialplan: false
};

class RealEstateHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newFixedAssetsData: new Bl.FixedAsset({ ...newFixedAssets, userid: getUserId() }),
      fixedAssetsData: [],
    };
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressAddProperty() {
    this.props.navigate("/realestatedetail", {
      state: {
        fixedAssetsData: this.state.newFixedAssetsData,
        isEditView: false,
      },
    });
  }


  renderNavView() {
    const items = getInvestmentPhysicalPath("RealEstate");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const information = "";
    const title = t("networthAssetsPA1");
    return <TitleView title={title} information={information} />;
  }

  renderProfileView() {
    return (
      <div className="resh_profile_view">
        <img
          src={RealEstate}
          alt={t("networthAssetsPA1")}
          className="resh_icon"
        />

        <div className="resh_add_property">
          <Button
            buttonName={t("realEstateButton")}
            onPressButton={this.onPressAddProperty.bind(this)}
          />
        </div>
      </div>
    );
  }
  renderDrawerContent() {
    const headerTitle = t("financialPlan");
    const step = 1;
    return <SideModel step={step} headerTitle={headerTitle}></SideModel>;
  }
  renderContentView() {
    return (
      <div className="resh_content_view">
        {this.renderTitleView()}
        {this.renderProfileView()}
      </div>
    );
  }

  render() {
    return (
      <div className="resh_container">
        {this.renderNavView()}
        {this.renderContentView()}
        {/* {this.renderDrawerContent()} */}
      </div>
    );
  }
}

export default RealEstateHome;
